<app-auth-layout
  [title]="'LOGIN.TITLE' | translate"
>
  <form [formGroup]="form" (ngSubmit)="onSubmit()" class="auth-form">
    <app-input
      type="email"
      [label]="'LOGIN.EMAIL' | translate"
      [placeholder]="'LOGIN.EMAIL_PLACEHOLDER' | translate"
      [control]="form.get('login')!"
    />
    <app-input
      type="password"
      [label]="'LOGIN.PASSWORD' | translate"
      [placeholder]="'LOGIN.PASSWORD_PLACEHOLDER' | translate"
      [control]="form.get('password')!"
    />
    <button class="forgot-password" (click)="onForgotPassword()" type="button">
      {{ 'LOGIN.FORGOT_PASSWORD' | translate }}
    </button>
    <div class="button-container">
      <button type="submit" class="button primary button-submit">
        {{ 'LOGIN.SUBMIT' | translate }}
      </button>
    </div>

    <div class="button-container">
      <button type="button" class="microsoft-button" (click)="onMicrosoftLogin()">
        <img
          src="assets/images/microsoft-logo.svg"
          alt="Microsoft"
          class="microsoft-logo"
        />
        <span>{{ 'LOGIN.MICROSOFT' | translate }}</span>
      </button>
    </div>

  </form>
</app-auth-layout>
